module.exports = __webpack_public_path__ + "img/logo.236aa38c.svg";